import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';

const DeleteModal = ({
  visible,
  onDelete,
  onCancel,
  loading,
  done,
  title,
  message,
  buttonText,
  confirmDisabled,
  className,
  children,
}) => (
  <Modal
    className={className}
    title={title || 'Izbrisi'}
    open={visible}
    footer={[
      <Button key="cancel" onClick={onCancel}>
        Ponisti
      </Button>,
      <Button
        type="primary"
        key="delete"
        onClick={onDelete}
        danger
        disabled={loading || done || confirmDisabled}
      >
        {loading ? (
          <img
            src="/assets/icons/add.svg"
            alt="Dodaj"
            className="animate-spin"
          />
        ) : done ? (
          <img
            src="/assets/icons/check.svg"
            alt="Check Icon"
            className="check-icon"
          />
        ) : (
          <>
            <img src="/assets/icons/delete-white.svg" alt="Obriši" />
            {buttonText || 'Izbrisi'}
          </>
        )}
      </Button>,
    ]}
    onCancel={onCancel}
  >
    <p>{message}</p>
    {children}
  </Modal>
);

DeleteModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  done: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  confirmDisabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default DeleteModal;
